import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

export function useIsMobile() {
    return !useMediaQuery(useTheme().breakpoints.up('sm'));
}

export function useIsTablet() {
    return useMediaQuery(useTheme().breakpoints.between('sm', 'md'))
}